<template>
  <div v-if="haveBooking">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <booking-campaign-banner v-if="booking && booking.campaign" :campaign="booking.campaign" />
        <div class="row">
          <div class="col-md-6">
            <h1>
              Overview
              <help-link v-if="!$vlastMode" :anchor="$route.name === 'bookings.show.payment' ? 'payment' : 'bookings'" />
            </h1>
          </div>
          <div class="col-md-6">
            <booking-status
              :booking="booking"/>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">

      <booking-progress v-if="$userIsClient || $userIsAdmin"
        :booking="booking">
      </booking-progress>

      <ul class="nav nav-pills nav-page" v-if="($paymentsModuleEnabled || $invoicesEnabledForUser) && ($userIsAdmin || $userIsClient)">
        <router-link active-class="active" :to="{ name: 'bookings.show', params: { id } }" tag="li" exact>
          <a>Overview</a>
        </router-link>

        <router-link v-if="booking.payments && booking.payments.length && $paymentsModuleEnabled" active-class="active" :to="{ name: 'bookings.show.payment', params: { id } }" tag="li" exact>
          <a>Payment</a>
        </router-link>
        <router-link v-else-if="$invoicesEnabledForUser" active-class="active" :to="{ name: 'bookings.show.payment', params: { id } }" tag="li" exact>
          <a>Invoice</a>
        </router-link>
      </ul>

      <ul class="nav nav-pills nav-page" v-else-if="($userIsTalent || $userIsManager) && $invoicesEnabledForUser">
        <router-link active-class="active" :to="{ name: 'bookings.show', params: { id } }" tag="li" exact>
          <a>Overview</a>
        </router-link>
        <router-link active-class="active" :to="{ name: 'bookings.show.invoice', params: { id } }" tag="li" exact>
          <a>Invoice</a>
        </router-link>
      </ul>

      <router-view/>

      <booking-terms-and-conditions-modal
        v-if="($userIsAdmin || $userIsClient) && bookingTermsAreNotAccepted"
        :booking="booking"
        :talents="bookingAttendingTalent"
        :property-mutator="setBookingProperty"/>

      <booking-terms-and-conditions-modal-no-action
        v-if="($userIsAdmin || $userIsClient) && bookingTermsAreAccepted"
        :booking="booking"
        :talents="bookingAttendingTalent"/>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { helpers } from 'mixins/bookings'
import BookingStatus from './BookingStatus'
import BookingProgress from './BookingProgress'
import BookingTermsAndConditionsModal from './BookingTermsAndConditionsModal'
import BookingTermsAndConditionsModalNoAction from './BookingTermsAndConditionsModalNoAction'
import HelpLink from 'components/globals/HelpLink'
import BookingCampaignBanner from './BookingCampaignBanner'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  props: ['id'],

  mixins: [helpers, OpportunityTracker],

  components: {
    BookingCampaignBanner,
    BookingStatus,
    BookingProgress,
    BookingTermsAndConditionsModal,
    BookingTermsAndConditionsModalNoAction,
    HelpLink
  },

  computed: {
    ...mapState('booking', ['booking']),
    ...mapState('clientConfig', ['client_config']),
    ...mapGetters('booking', ['haveBooking'])
  },

  created () {
    this.getBooking({ id: this.id })
      .then(() => {
        this.redirectToOverviewIfRequired()
        if (!this.is_offer) {
          this.$echo.private(`${this.client_config.slug}.booking.${this.id}`).listen('BookingFileUploaded', (payload) => {
            this.addFile({ file: payload.file })
          })
        }
        this.trackEvent(this.analytics.V2.JobOpenEvent)
      }).catch((error) => {
        this.handleCaughtHttpExceptionForBooking(error, 'The booking could not be found.')
      })
  },

  beforeDestroy () {
    this.resetBooking()
    this.clearFiles()
    this.$echo.leave(`${this.client_config.slug}.booking.${this.id}`)
  },

  methods: {
    ...mapActions('booking', ['getBooking', 'resetBooking', 'setBookingProperty']),
    ...mapActions('booking/file', ['clearFiles', 'addFile']),

    redirectToOverviewIfRequired () {
      if (this.$route.name === null || this.$route.name === undefined) {
        this.$router.replace({ name: 'bookings.show' })
      }
    }
  }
}
</script>
